export enum AnalyticsPlatform {
    GoogleAnalytics = "ga",
    GoogleTagManager = "gtm",
    FacebookPixel = "fbpixel",
}
